import axios from "axios";

const iamAPI = axios.create();

iamAPI.interceptors.request.use((config) => {
  config.headers!.LANG = localStorage.getItem("LANGUAGE") || "";
  return config;
});


iamAPI.defaults.withCredentials = true;

export default iamAPI;